import {
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { CustomeDialog, InputControl } from "../../../shared";
import { DeleteCustomDateDiaog } from "../components";

export const CreateDateAssignTab = (props) => {
  const {
    templates,
    onChangeMultipleDate,
    onSaveCustomDays,
    onDeleteTagSelect,
    ////////////////
    WeekDays,
    handleRepeatOptionChange,
    ListofDropdown,
    onChangeHandler,
    RadioButtonChange,
    handleDayClick,
    MonthDropdown,
    monthOptionChange,
    WeekOfMonth,
    weekOfMonthOptionChange,
    weekDaysOptionChange,
    onChangeYear,
    onChangeSceduler,
    onChangeDate,
    DaysOfWeekOptionChange,
    OptionChange,
    WeekDaysOptionChange,
    handleCreateDateAssign,
    validator,
  } = props;

  const format = "YYYY-MM-DD";
  const {
    date_range_week,
    month_onday,
    month_onthe,
    year_on,
    year_onthe,
    start_date,
    end_date,
    period,
    date_range_radio,
    date_range_month_radio,
    drop_down_list,
  } = templates.data;
  const renderRepeatComponent = () => {
    const dayAbbreviations = {
      Monday: "Mon",
      Tuesday: "Tue",
      Wednesday: "Wed",
      Thursday: "Thu",
      Friday: "Fri",
      Saturday: "Sat",
      Sunday: "Sun",
    };

    switch (drop_down_list) {
      case 2:
        return (
          <Stack direction="row" gap="10px">
            {WeekDays?.map((day, i) => {
              return (
                <Chip
                  key={i}
                  sx={{
                    borderRadius: "53px",
                    border: "1px solid #DFE8F2",
                    width: "50px",
                    height: "50px",
                    "& .MuiChip-label": {
                      fontSize: "11px",
                      lineHeight: "14.52px",
                      fontWeight: "500px",
                      color: date_range_week?.date?.includes(day?.value)
                        ? "white"
                        : "black",
                    },
                  }}
                  label={dayAbbreviations[day?.label]}
                  variant={
                    date_range_week?.date?.includes(day?.value)
                      ? "filled"
                      : "outlined"
                  }
                  color="info"
                  onClick={() => handleDayClick(day?.value)}
                />
              );
            })}
          </Stack>
        );

      case 3:
        return (
          <Stack>
            <FormControl>
              <RadioGroup
                sx={{
                  gap: "18px",
                }}
                value={date_range_month_radio}
                onChange={(event) =>
                  RadioButtonChange(
                    event.target.value,
                    "date_range_month_radio"
                  )
                }
              >
                <Stack direction="row" gap="10px">
                  <FormControlLabel control={<Radio />} label="on" value={4} />

                  <InputControl
                    // sx={{ width: "220px" }}
                    value={month_onday.day}
                    type="text"
                    name="day"
                    onChange={onChangeSceduler}
                    disabled={date_range_month_radio === 5}
                    error={
                      date_range_month_radio !== 5 &&
                      validator.current.message(
                        "day",
                        month_onday.day,
                        "required"
                      )
                    }
                    helperText={
                      date_range_month_radio !== 5 &&
                      validator.current.message(
                        "day",
                        month_onday.day,
                        "required"
                      )
                    }
                  />
                </Stack>
                <Stack direction="row" gap="10px">
                  <FormControlLabel
                    control={<Radio />}
                    label="on the"
                    value={5}
                  />

                  <InputControl
                    type="dropdown"
                    fullWidth
                    options={WeekOfMonth}
                    name="weekofmonth"
                    value={
                      WeekOfMonth?.find(
                        (value) => value.value === month_onthe?.weekofmonth
                      ) || null
                    }
                    onChange={(event, option) =>
                      weekOfMonthOptionChange(event, option)
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    // sx={{
                    //   width: "242px",
                    // }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          date_range_month_radio !== 4 &&
                          validator.current.message(
                            "week of month",
                            month_onthe?.weekofmonth,
                            "required"
                          )
                        }
                        helperText={
                          date_range_month_radio !== 4 &&
                          validator.current.message(
                            "week of month",
                            month_onthe?.weekofmonth,
                            "required"
                          )
                        }
                      />
                    )}
                    disabled={date_range_month_radio === 4}
                  />
                  <InputControl
                    type="dropdown"
                    fullWidth
                    options={WeekDays}
                    name="dayofweek"
                    value={
                      WeekDays?.find(
                        (value) => value.value === month_onthe?.dayofweek
                      ) || null
                    }
                    onChange={(event, option) =>
                      weekDaysOptionChange(event, option)
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    sx={{
                      width: "242px",
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          date_range_month_radio !== 4 &&
                          validator.current.message(
                            "day of week",
                            month_onthe?.dayofweek,
                            "required"
                          )
                        }
                        helperText={
                          date_range_month_radio !== 4 &&
                          validator.current.message(
                            "day of week",
                            month_onthe?.dayofweek,
                            "required"
                          )
                        }
                      />
                    )}
                    disabled={date_range_month_radio === 4}
                  />
                </Stack>
              </RadioGroup>
            </FormControl>
          </Stack>
        );

      case 4:
        return (
          <Stack>
            <FormControl>
              <RadioGroup
                sx={{
                  gap: "18px",
                }}
                value={date_range_radio}
                onChange={(event) =>
                  RadioButtonChange(event.target.value, "date_range_radio")
                }
              >
                <Stack direction="row" gap="10px">
                  <FormControlLabel
                    control={<Radio />}
                    label="on day"
                    value={6}
                  />

                  <InputControl
                    type="dropdown"
                    fullWidth
                    options={MonthDropdown}
                    name="month"
                    value={
                      MonthDropdown?.find(
                        (value) => value.value === year_on?.month
                      ) || null
                    }
                    onChange={(event, option) =>
                      monthOptionChange(event, option)
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    // sx={{
                    //   width: "250px",
                    // }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          date_range_radio !== 7 &&
                          validator.current.message(
                            "month",
                            year_on?.month,
                            "required"
                          )
                        }
                        helperText={
                          date_range_radio !== 7 &&
                          validator.current.message(
                            "month",
                            year_on?.month,
                            "required"
                          )
                        }
                      />
                    )}
                    disabled={date_range_radio === 7}
                  />
                  <InputControl
                    // sx={{ width: "220px" }}
                    value={year_on?.day}
                    type="text"
                    name="day"
                    onChange={onChangeYear}
                    error={
                      date_range_radio !== 7 &&
                      validator.current.message("day", year_on?.day, "required")
                    }
                    helperText={
                      date_range_radio !== 7 &&
                      validator.current.message("day", year_on?.day, "required")
                    }
                    disabled={date_range_radio === 7}
                  />
                </Stack>
                <Stack direction="row" gap="10px" alignItems="center">
                  <FormControlLabel
                    control={<Radio />}
                    label="on the"
                    value={7}
                  />
                  <InputControl
                    type="dropdown"
                    fullWidth
                    options={WeekOfMonth}
                    name="dayofweek"
                    value={
                      WeekOfMonth?.find(
                        (value) => value.value === year_onthe?.dayofweek
                      ) || null
                    }
                    onChange={(event, option) =>
                      DaysOfWeekOptionChange(event, option)
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          date_range_radio !== 6 &&
                          validator.current.message(
                            "day of week",
                            year_onthe?.dayofweek,
                            "required"
                          )
                        }
                        helperText={
                          date_range_radio !== 6 &&
                          validator.current.message(
                            "day of week",
                            year_onthe?.dayofweek,
                            "required"
                          )
                        }
                      />
                    )}
                    disabled={date_range_radio === 6}
                  />
                  <InputControl
                    type="dropdown"
                    fullWidth
                    options={WeekDays}
                    name="date"
                    value={
                      WeekDays?.find(
                        (value) => value.value === year_onthe?.date
                      ) || null
                    }
                    onChange={(event, option) =>
                      WeekDaysOptionChange(event, option)
                    }
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          date_range_radio !== 6 &&
                          validator.current.message(
                            "date",
                            year_onthe?.date,
                            "required"
                          )
                        }
                        helperText={
                          date_range_radio !== 6 &&
                          validator.current.message(
                            "date",
                            year_onthe?.date,
                            "required"
                          )
                        }
                      />
                    )}
                    disabled={date_range_radio === 6}
                  />
                  <Typography>of</Typography>
                  <InputControl
                    type="dropdown"
                    fullWidth
                    options={MonthDropdown}
                    name="month"
                    value={
                      MonthDropdown?.find(
                        (value) => value.value === year_onthe?.month
                      ) || null
                    }
                    onChange={(event, option) => OptionChange(event, option)}
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          date_range_radio !== 6 &&
                          validator.current.message(
                            "month",
                            year_onthe?.month,
                            "required"
                          )
                        }
                        helperText={
                          date_range_radio !== 6 &&
                          validator.current.message(
                            "month",
                            year_onthe?.month,
                            "required"
                          )
                        }
                      />
                    )}
                    disabled={date_range_radio === 6}
                  />
                </Stack>
              </RadioGroup>
            </FormControl>
          </Stack>
        );
      default:
        return null;
    }
  };
  return (
    <Box
      sx={{
        padding: "16px",
        height: "calc(90vh - 128px)",
        overflowY: "auto",
      }}
    >
      {validator.current.purgeFields()}
      <Stack
        borderRadius="4px"
        backgroundColor="#F7FAFC"
        height="87px"
        direction="row"
        justifyContent="space-between"
        padding={2}
        border="1px"
      >
        <Box>
          <Typography variant="h6">Set Recurring Dates?</Typography>
          <Typography fontSize="14px" fontWeight={400}>
            Customize your schedule to automatically repeat this template on
            your preferred dates.
          </Typography>
        </Box>

        <Switch
          name="is_create_date_assign"
          checked={templates.is_create_date_assign ? true : false}
          value={templates.is_create_date_assign}
          onChange={handleCreateDateAssign}
        />
      </Stack>
      {/* //////////////////////////////////////body part//////////////////////////////// */}
      {templates.is_create_date_assign === 1 && (
        <Box height={"360px"} padding={"20px"}>
          <Grid container spacing={2}>
            {/* <Grid item xs={8} sm={8}> */}
            <Stack paddingTop={2} gap={2}>
              <InputControl
                name="start_date"
                label="Start Date"
                sx={{ minWidth: "714px" }}
                value={start_date ? start_date : null}
                type="datePicker"
                disablePast
                required
                inputFormat="dd/MM/yyyy"
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
                onChange={(dateValue) => onChangeDate("start_date", dateValue)}
                error={validator.current.message(
                  "Start Date",
                  start_date,
                  "required"
                )}
                helperText={validator.current.message(
                  "Start Date",
                  start_date,
                  "required"
                )}
              />
              <Stack
                direction="row"
                alignItems="center"
                flex={1}
                justifyContent="space-between"
              >
                <InputControl
                  sx={{ minWidth: "90%" }}
                  name="end_date"
                  label="End Date"
                  value={end_date ? end_date : null}
                  type="datePicker"
                  disablePast
                  inputFormat="dd/MM/yyyy"
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                  onChange={(dateValue) => onChangeDate("end_date", dateValue)}
                />
                <Button
                  type="button"
                  size="small"
                  variant="text"
                  color="error"
                  onClick={() => onChangeDate("end_date", "")}
                >
                  Remove
                </Button>
              </Stack>
              <Stack direction="row" gap="10px" alignItems="center">
                <Typography width="200px">Repeat Every</Typography>
                <InputControl
                  value={period}
                  sx={{ width: "320px" }}
                  type="text"
                  name="period"
                  onChange={onChangeHandler}
                  error={validator.current.message(
                    "period",
                    period,
                    "required"
                  )}
                />
                <InputControl
                  type="dropdown"
                  fullWidth
                  sx={{ width: "320px" }}
                  options={ListofDropdown}
                  name="drop_down_list"
                  value={
                    ListofDropdown?.find(
                      (value) => value.value === drop_down_list
                    ) || null
                  }
                  onChange={(event, option) =>
                    handleRepeatOptionChange(event, option)
                  }
                  getOptionLabel={(option) => option?.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="drop_down_list"
                      required
                      error={validator.current.message(
                        "drop_down_list",
                        drop_down_list,
                        "required"
                      )}
                    />
                  )}
                />
              </Stack>
              <FormHelperText sx={{ color: "error.main", ml: "25%" }}>
                {validator.current.message(
                  "Repeat Every",
                  period && drop_down_list,
                  "required"
                )}
              </FormHelperText>

              {renderRepeatComponent()}
            </Stack>
          </Grid>
        </Box>
      )}

      {/* ///////////////////////////////custom dates///////////////////////////////// */}
      <Stack
        padding="6px 8px"
        spacing="8px"
        mt={
          (templates.data.drop_down_list === 3 ||
            templates.data.drop_down_list === 4) &&
          templates.is_create_date_assign === 1
            ? 9
            : 0
        }
      >
        <Stack
          sx={{
            py: "12px",
            height: "55px",
            justifyContent: "center",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Typography fontSize="18px" fontWeight={600}>
            Custom Dates
          </Typography>
        </Stack>

        <Stack direction="row" gap="8px">
          <DatePicker
            name="custom_dates"
            value={templates?.data?.custom_dates}
            multiple
            minDate={moment().format("YYYY-MM-DD")}
            sort
            format={format}
            calendarPosition="top-left"
            onChange={(e) => onChangeMultipleDate(e)}
            render={(value, openCalendar) => (
              <Box onClick={openCalendar}>
                <InputControl
                  size="small"
                  placeholder="Select Dates"
                  readOnly
                  autocomplete="off"
                  InputProps={{
                    readOnly: true,
                    style: { cursor: "pointer" },
                    endAdornment: (
                      <InputAdornment position="end">
                        <img
                          src="/icons/ic_calendar.png"
                          alt="Calendar Icon"
                          style={{
                            width: "20px",
                            height: "20px",
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            )}
          />

          <Button
            variant="contained"
            size="small"
            onClick={() => onSaveCustomDays()}
            disabled={templates?.isDateSaveButton}
          >
            Save
          </Button>
        </Stack>

        <Stack direction="row" gap="12px" flexWrap="wrap">
          {(Array.isArray(templates?.data?.custom_dates_view)
            ? templates?.data?.custom_dates_view
            : []
          ).map((data, index) => (
            <Chip
              key={index}
              variant="outlined"
              color="gray"
              label={moment(data).format("DD-MM-YYYY")}
              deleteIcon={<CloseIcon />}
              onDelete={() => {
                onDeleteTagSelect(data, true);
              }}
              sx={{
                width: "117px",
                "& .MuiChip-deleteIcon": {
                  fontSize: "18px",
                },
              }}
            />
          ))}
        </Stack>
      </Stack>

      <CustomeDialog
        PaperProps={{
          sx: {
            width: "500px",
          },
        }}
        closeIcon={false}
        open={templates?.isDeleteDialogOpen}
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            position="sticky"
            zIndex={999}
            bgcolor="#fff"
            top={0}
          >
            <Stack direction="row" alignItems="center" ml={2}>
              <img src="/icons/ic_pair_dialog.svg" alt="pair dialog" />
              <Typography
                fontWeight={500}
                variant="body1"
                padding="15px"
                fontSize={20}
              >
                Remove Date?
              </Typography>
            </Stack>
          </Stack>
        }
        content={
          <DeleteCustomDateDiaog
            templates={templates}
            onDeleteTagSelect={onDeleteTagSelect}
            onSaveCustomDays={onSaveCustomDays}
          />
        }
      />
    </Box>
  );
};
